/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional slot duration override in minutes. Applied only if the EventKind allows custom duration.
 */
export type CreateSlotsRequestDurationMinutes = number | null;
